import { INITIALIZE_ASSIGN_PRODUCT_FORM } from '../actionTypes';
import { installersActions } from '../reducer';

export default (values) =>
    installersActions[INITIALIZE_ASSIGN_PRODUCT_FORM](values);
